import { Sofa, Layers, Lightbulb, Package } from 'lucide-react';

const services = [
  {
    icon: Sofa,
    title: 'Furniture',
    description: 'Professional furniture solutions for commercial and residential projects',
  },
  {
    icon: Layers,
    title: 'Carpets & Flooring',
    description: 'Quality flooring options for all interior requirements',
  },
  {
    icon: Lightbulb,
    title: 'Lighting Equipment',
    description: 'Complete lighting solutions for professional spaces',
  },
  {
    icon: Package,
    title: 'Interior Fittings',
    description: 'Comprehensive interior fittings for complete installations',
  },
];

export function Services() {
  return (
    <section className="py-20 px-6 bg-neutral-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-4xl font-light text-neutral-900 mb-12 text-center">
          What We Supply
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service) => (
            <div
              key={service.title}
              className="bg-white p-8 rounded-sm shadow-sm hover:shadow-md transition-shadow duration-200"
            >
              <service.icon className="w-12 h-12 text-neutral-700 mb-4" strokeWidth={1.5} />
              <h3 className="text-xl font-normal text-neutral-900 mb-2">{service.title}</h3>
              <p className="text-neutral-600 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
